import { useUserInfoStore } from "~/stores/userInfoStore";

const exemptSections = [
    "build",
    "asset",
    "industry",
]



const checkUnavaiableData = [
    {
        name: "品牌",
        all_key: "brand_range_allow_all",
        instance_key: "available_brands",
    },
    {
        name: "集团",
        all_key: "group_range_allow_all",
        instance_key: "available_groups",
    },
    {
        name: "酒管集团",
        all_key: "group_range_allow_all",
        instance_key: "available_groups",
    },
    {
        name: "业主集团",
        all_key: "group_range_allow_all",
        instance_key: "available_groups",
    },
    {
        name: "酒店",
        all_key: "hotel_range_allow_all",
        instance_key: "available_hotels",
    },
    {
        name: "城市",
        all_key: "city_range_allow_all",
        instance_key: "available_cities",
    },
]

export const checkTabUnavailable = (tab: any):string => {
    const userInfo = useUserInfoStore().info as any
    for (const item of checkUnavaiableData){
        if (tab.name == item.name){
            if (userInfo[item.all_key]){
                return null
            }
            if (userInfo[item.instance_key] && userInfo[item.instance_key].length){
                return null
            }
            return `${item.name} 仅限付费用户访问`
        }
    }
    return null
}

export const checkNavNodeAvailable = ( node: any, instance?: string) => {
    const userInfo = useUserInfoStore().info as any

    console.log("checkNodeAvailable", node, userInfo)
    if (node.display == "四库赋能"){
        if (userInfo.user_type == "hm_employee"){
            return true
        }
        return false
    }
    if (node.display == "优选资源"){
        if (userInfo.user_type == "hm_employee"){
            return true
        }
        if (userInfo.user_type == "new_hotel"){
            return true
        }
        return false
    }
    return true
}

const overridePaths = [
    "评估展望/品牌/品牌介绍/",
    "我的赋能链/公司介绍/",
    "华美/华美简介/",
    "行业观察",
    "优选资源",
    "项目",
    "我的",
    "我的赋能链",
]

const allowAllMap = {
    "四库赋能-酒店建设": "jiudianjianshe_allow_all",
    "四库赋能-酒店资管": "jiudianziguan_allow_all",
    "四库赋能-酒店+": "jiudianjia_allow_all",

    "评估展望/品牌": "brand_range_allow_all",
    "评估展望/集团": "group_range_allow_all",
    "评估展望/酒店": "hotel_range_allow_all",
    "评估展望/城市": "city_range_allow_all",

    "智能工具": "zhinenggongju_allow_all",
    "建设数据": "jiansheshuju_allow_all",
    "经营案例": "jingyinganli_allow_all",
    "优选资源": "youxuanziyuan_allow_all",

    "五星酒店": "wuxingjiudian_allow_all",
    "改进建设": "gaijinjianshe_allow_all",
    "提升经营": "tishengjingying_allow_all",
    "盘活资产": "panhuozichan_allow_all",
    "赋能生态": "funengshengtai_allow_all",
}

const instanceMap = {
    "评估展望/品牌": "available_brands",
    "评估展望/集团": "available_groups",
    "评估展望/酒店": "available_hotels",
    "评估展望/城市": "available_cities",
}

export const checkPathAvailable = ( _targetPath: string, instance?: string) => {

    let targetPath = _targetPath.replace(/\/$/, '') + '/'
    targetPath = targetPath.replace(/^\//, '')
    targetPath = targetPath.replace(/^内容文件/, '')
    targetPath = targetPath.replace(/^\//, '')

    const userInfo = useUserInfoStore().info as any

    // return false
    console.log('checkPathAvailable userInfo', userInfo)
    console.log('checkPathAvailable path', targetPath, instance)
    console.log("allowAllMap", allowAllMap)
    console.log("instanceMap", instanceMap)
    console.log("targetPath", targetPath)

    for (const path of overridePaths){
        if (targetPath.startsWith(path)){
            return true
        }
    }
    for (const [key, value] of Object.entries(allowAllMap)){
        if (targetPath.startsWith(key) && userInfo[value]){
            return true
        }
    }

    for (const [key, value] of Object.entries(instanceMap)){
        if(!userInfo[value]) continue
        console.log("userInfo[value].includes(instance)",userInfo[value].includes(instance), userInfo[value], instance)
        if (targetPath.startsWith(key) && userInfo[value].includes(instance)){
            return true
        }
    }

    if (targetPath.match(/^华美/)){
        if((userInfo.user_type == "华美员工")
        ||(userInfo.user_company == "华美顾问")){
            return true
        }
        return false
    }

    for (const path of userInfo[`available_paths`].filter(Boolean)){
        if (targetPath.startsWith(path)){
            return true
        }
    }
    return false
}
